import { render, staticRenderFns } from "./UploadDetail.vue?vue&type=template&id=ceab7254&scoped=true&"
import script from "./UploadDetail.vue?vue&type=script&lang=js&"
export * from "./UploadDetail.vue?vue&type=script&lang=js&"
import style0 from "./UploadDetail.vue?vue&type=style&index=0&id=ceab7254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceab7254",
  null
  
)

export default component.exports